import { render } from "./ImageGeneratorPropsCmp.vue?vue&type=template&id=0be486fe"
import script from "./ImageGeneratorPropsCmp.vue?vue&type=script&lang=js"
export * from "./ImageGeneratorPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__